import React from 'react';

const privacyPoints = [
    {
        icon: '/assets/img/Security.png', // Keep blank for now
        text: "There's no room for mistakes because we didn’t leave any.",
    },
    {
        icon: '/assets/img/Savings.png',
        text: 'DigitMoney ensures that all your personal data are encrypted.',
    },
    {
        icon: '/assets/img/Agreement.png',
        text: "What's yours, remains only yours",
    },
];

const PrivacySection = () => {
    return (
        <section className="w-full bg-black  min-h-[80vh]  text-white px-4 py-24 sm:bg-black/30 md:py-[100px]">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-10 ">
                {/* Text Section */}
                <div className="flex-1">
                    <h2 style={{ fontFamily: 'myFirstFont7' }} className="text-3xl md:text-[60px]  mb-6 leading-[1]">
                        We don’t share <br className="hidden md:block" /> your data!
                    </h2>
                    <ul style={{ fontFamily: "Atkinson-regular" }} className="space-y-10 sm:pl-[140px] sm:pt-[60px]">
                        {privacyPoints.map((item, index) => (
                            <li key={index} className="flex items-center  gap-4">
                                <img src={item.icon} alt="" className="h-[55px]  mt-1" />
                                <p className="text-[18px] sm:text-[20px] md:text-[22px] md:w-[350px] text-base text-[#818181]">{item.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Image Section */}
                <div className=" relative mt-3 pd-[100px] sm:mt-auto flex-1 flex justify-center md:justify-end">
                    <img src="/assets/img/shieldImg.png" alt="Shield Character" className="w-[280px] md:w-[420px] z-10" />
                    <img
                        src="/assets/img/6fdcd2efa6f5b6a0f82607d1a7abf7394ccde044.png"
                        className="absolute top-[-30%] left-[-15%] h-[269px] w-[269px] brightness-[0.2] sm:top-[-100px] sm:left-[25px] sm:h-[394px] sm:w-[394px] sm:brightness-[0.3] z-0"
                        alt=""
                    />
                    <img
                        src="/assets/img/6fdcd2efa6f5b6a0f82607d1a7abf7394ccde044.png"
                        className="absolute top-[60%] left-[5%] h-[209px] w-[209px] brightness-[0.2] sm:bottom-[-100px] sm:left-[150px] sm:h-[296px] sm:w-[296px] sm:brightness-[0.2] z-0"
                        alt=""
                    />
                </div>
            </div>
        </section>
    );
};

export default PrivacySection;
